export default __webpack_public_path__ + "static/media/view-report.f78f724b.svg";